import { graphql } from 'react-relay';

export const AddAccount = graphql`
  mutation mutationsAddAccountMutation($name: String!) {
    addAccount(input: { name: $name }) {
      id
    }
  }
`;

export const UpdateUser = graphql`
  mutation mutationsUpdateUserMutation(
    $userID: ID!
    $firstname: String
    $lastname: String
    $password: String
    $profileImage: ImageUpload
  ) {
    updateUser(
      input: {
        firstname: $firstname
        lastname: $lastname
        password: $password
        userID: $userID
        profileImage: $profileImage
      }
    ) {
      id
    }
  }
`;

export const AddService = graphql`
  mutation mutationsAddServiceMutation(
    $accountID: ID!
    $name: String!
    $description: String!
  ) {
    addService(
      input: { accountID: $accountID, name: $name, description: $description }
    ) {
      id
    }
  }
`;

export const UpdateService = graphql`
  mutation mutationsUpdateServiceMutation(
    $serviceID: ID!
    $name: String
    $description: String
    $image: ImageUpload
  ) {
    updateService(
      input: {
        serviceID: $serviceID
        name: $name
        description: $description
        image: $image
      }
    ) {
      id
    }
  }
`;

export const DeleteService = graphql`
  mutation mutationsDeleteServiceMutation($serviceID: ID!) {
    deleteService(input: { serviceID: $serviceID })
  }
`;

export const AddCharge = graphql`
  mutation mutationsAddChargeMutation(
    $serviceID: ID!
    $name: String!
    $description: String!
    $prices: [ChargePriceInput!]!
    $metricName: String
    $chargeType: ChargeType!
  ) {
    addCharge(
      input: {
        serviceID: $serviceID
        name: $name
        description: $description
        prices: $prices
        metricName: $metricName
        chargeType: $chargeType
      }
    ) {
      id
    }
  }
`;

export const UpdateCharge = graphql`
  mutation mutationsUpdateChargeMutation(
    $chargeID: ID!
    $name: String!
    $description: String!
  ) {
    updateCharge(
      input: { chargeID: $chargeID, name: $name, description: $description }
    ) {
      id
    }
  }
`;

export const DeleteCharge = graphql`
  mutation mutationsDeleteChargeMutation($chargeID: ID!) {
    deleteCharge(input: { chargeID: $chargeID })
  }
`;

export const OnboardMerchant = graphql`
  mutation mutationsOnboardMerchantMutation($accountID: ID!) {
    onboardMerchant(input: { accountID: $accountID }) {
      stripeOnboardURL
    }
  }
`;

export const SubscribeToService = graphql`
  mutation mutationsSubscribeMutation(
    $accountID: ID!
    $serviceID: ID!
    $currency: String!
  ) {
    subscribe(
      input: {
        accountID: $accountID
        serviceID: $serviceID
        currency: $currency
      }
    ) {
      id
    }
  }
`;

export const UpdateMerchantPayments = graphql`
  mutation mutationsUpdateMerchantMutation($accountID: ID!) {
    updateMerchantPayments(input: { accountID: $accountID }) {
      updateLink
    }
  }
`;

export const CreateSubscriberSetupIntent = graphql`
  mutation mutationsCreateSubscriberSetupIntentMutation(
    $accountID: ID!
    $cardToken: String!
    $taxID: TaxID
  ) {
    createSubscriberSetupIntent(
      input: { accountID: $accountID, cardToken: $cardToken, taxID: $taxID }
    ) {
      clientSecret
    }
  }
`;

export const Logout = graphql`
  mutation mutationsLogoutMutation {
    logout
  }
`;

export const DeleteSubscription = graphql`
  mutation mutationsDeleteSubscriptionMutation($subscriptionID: ID!) {
    deleteSubscription(input: { subscriptionID: $subscriptionID })
  }
`;

export const SendPasswordReset = graphql`
  mutation mutationsSendPasswordResetMutation($email: String!) {
    sendPasswordReset(input: { email: $email })
  }
`;

export const ResetPassword = graphql`
  mutation mutationsResetPasswordMutation($token: String!, $password: String!) {
    resetPassword(input: { token: $token, password: $password })
  }
`;

export const AddCurrency = graphql`
  mutation mutationsAddCurrencyMutation($input: AddServiceCurrencyInput!) {
    addServiceCurrency(input: $input) {
      id
    }
  }
`;
